<template>
<div class='knowledge-tab'>
  <div class="list-knowledge" v-for="knowledge in knowledgeRows">
      <div @click="getKnowledge(knowledge)">
          <div class="row">
            <div class="box-new">
          <template v-if="knowledgeDateInMonth(knowledge.date)">
                  <img class="ico-new" src="./img/new-01.png">
          </template>
          <template v-else>
            <img class="ico-new" src="./img/old-01.png">
          </template>
            </div>
            <div class="date">{{ knowledge.date }}</div>
        <div class="box-ico">
          <a class="fa fa-paperclip ico-knowledge1 dash-color-skin" target="_blank" :href="knowledge.file_path" download v-show="knowledge.file_path" @click.stop title="Download Attach File"></a>
        </div>
        <div class="box-ico">
          <a class="fa fa-link ico-knowledge2 dash-color-skin" target="_blank" :href="'http://' + knowledge.link" v-show="knowledge.link" @click.stop title="Open Link"></a>
        </div>
      </div>
      <div class="row">
        <div class="col-xs-12 topic-knowledge">{{ knowledge.title }}</div>
      </div>
    </div>
  </div>
  <hrms-infinite-loading v-if="triggerKnowledgeInfiniteBool" @infinite="onInfinite" ref="knowledgeLoading" />
</div>
</template>

<script>
import moment from 'moment'

export default {
  name: 'knowledge-index',
  props: [ 'knowledges', 'getKnowledge', 'subject', 'receivedKnowledgesInfiniteLoading', 'triggerKnowledgeInfiniteBool', 'triggerResetBool' ],
  data () {
    return {
      knowledgeRows: [],
      page: 1,
      limit: 10
    }
  },
  watch: {
    triggerResetBool () {
      if (this.triggerResetBool) {
        this.knowledgeRows = []
        this.page = 1
        this.limit = 10
        this.$nextTick(function () {
          this.$refs.knowledgeLoading.$emit('$InfiniteLoading:reset')
        })
        this.$emit('disableTriggerResetBool')
      }
    }
  },
  methods: {
    onInfinite ($state) {
      this.receivedKnowledgesInfiniteLoading(this.params($state))
      this.page++
    },
    params ($state) {
      return {
        searchParams: {
          p_subject: this.subject,
          p_page: this.page,
          p_limit: this.limit
        },
        $state: $state,
        triggerInfinite: this.triggerInfinite
      }
    },
    triggerInfinite ({ data, $state }) {
      if (data.rows.length) {
        this.knowledgeRows = this.knowledgeRows.concat(data.rows)
        $state.loaded()
      } else {
        $state.complete()
      }
    },
    knowledgeDateInMonth (date) {
      return (parseInt(date.replace(/\//g, '').substr(2, 2)) === (moment().month() + 1)) && (parseInt(date.replace(/\//g, '').substr(4, 4)) === moment().year())
    }
  }
}
</script>


// WEBPACK FOOTER //
// index.vue?a23ed34a